import React, { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import Conversation from './Conversation';
import { useParams } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { IoChatbubblesOutline } from "react-icons/io5";
import EmptyElement from 'elements/EmptyElement';
import Banner from 'elements/Banner';
import Badge from '@mui/material/Badge';

const drawerWidth = 240;


export default function MessagesList() {

  const {conversation_id} = useParams<{conversation_id: string}>();

  const [conversations, setConversations] = useState<any[]>([]); // Inicializamos como arreglo vacío
  const [selectedConversationId, setSelectedConversationId] = useState<string | null>(null);


  const loadList = async () => {
    await ApiRequest({
      url: '/messages/conversations',
      method: 'GET',
      setResponse: (response: any) => {
        setConversations(response.conversations || []); // Si no hay conversaciones, usa arreglo vacío
      },
    });
  };

  useEffect(() => {
    loadList();
  }, []);
  
    useEffect(() => {
        if (conversation_id) {
        setSelectedConversationId(conversation_id);
        }
    }, [conversation_id]);


  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleConversationOpen = (conversationId: string) => {
    setSelectedConversationId(conversationId);
    setConversations(conversations.map(conversation => 
      conversation.conversation_id === conversationId 
        ? { ...conversation, unreadCount: 0 } 
        : conversation
    ));
  };

  const drawer = (
    <div>
      <Divider />
      {conversations.length > 0 ? (
      <List>
          <h3 style={{ padding: '20px' }}>Conversaciones</h3>

            {conversations.map((conversation: any) => (
              <ListItem key={conversation.conversation_id} disablePadding>
                <ListItemButton onClick={() => handleConversationOpen(conversation.conversation_id)}>
                  <ListItemIcon>
                    <Badge badgeContent={conversation.unreadCount} color="primary">
                      <IoChatbubblesOutline size={30} style={{ color: '#C8C5C5' }} />
                    </Badge>
                  </ListItemIcon>
                  <ListItemText primary={conversation.name + ' ' + conversation.lastname} />
                </ListItemButton>
              </ListItem>
            ))}

      </List>
      ) : (
        <EmptyElement title='No hay conversaciones' />
      )}
            
    </div>
  );


  return (
    <>
    
    <div id='messages_content' className='content'>
      <div id='messages_container'>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <CssBaseline />
          <AppBar
            position="static"
            sx={{
              width: '100%',
              display: { xs: mobileOpen ? 'none' : 'block', sm: 'none' }
            }}
          >
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                Mensajes
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ height: '100%', display: 'flex' }}>
            <Box
              component="nav"
              sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
              aria-label="mailbox folders"
            >
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                {drawer}
              </Drawer>
              <Drawer
                variant="permanent"
                sx={{
                  display: { xs: 'none', sm: 'block' },
                  '& .MuiDrawer-paper': { 
                    boxSizing: 'border-box', 
                    position: "absolute", 
                    width: drawerWidth },
                }}
                open
              >
                {drawer}
              </Drawer>
            </Box>

              <div className='conversation'>
                {selectedConversationId ? (
                  <Conversation conversationId={selectedConversationId} />
                ) : (
                  <div style={{ padding: '20px' }}>
                    <h3>Seleccione una conversación para ver los mensajes</h3>
                  </div>
                )}
              </div>
          </Box>
        </Box>
      </div>
    </div>
    <Banner section='chat' />
    </>
  );
}




